module.exports = __webpack_public_path__ + "static/media/cogs.61cbebbf.svg";